export const PAYMENTS = '/payments'
export const STUDENT_PAYMENTS = '/student-payments'
export const TEACHER_INCOMES = '/teacher-incomes'
